import React, { useEffect, useState } from 'react';
import { PartyPopper } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { DEAL_STAGES, DealDetailDialog } from '../pages/FiDeals';

export const SalesJourney = () => {
  const [deals, setDeals] = useState([]);
  const [feed, setFeed] = useState([]);
  const [detailId, setDetailId] = useState(null);

  const load = async () => {
    try {
      const [d, f] = await Promise.all([api.get('/deals'), api.get('/sales-feed')]);
      setDeals(d.data.filter((x) => x.status !== 'DELIVERED'));
      setFeed(f.data);
    } catch (e) {}
  };
  useEffect(() => { load(); const iv = setInterval(load, 30000); return () => clearInterval(iv); }, []);

  return (
    <>
      {feed.length > 0 && (
        <div className="ent-panel" data-testid="sales-feed">
          <div className="ent-panel-head"><PartyPopper className="w-3.5 h-3.5 t-ok" /> Today's Sales</div>
          <div className="flex divide-x divide-border overflow-x-auto">
            {feed.map((s) => (
              <button key={s.id} onClick={() => setDetailId(s.id)} className="shrink-0 px-4 py-2.5 text-left hover:bg-primary/5 transition-colors">
                <p className="text-[13px] font-medium">{s.salesperson_name?.split(' ')[0]} vendeu {s.vehicle_desc}</p>
                <p className="text-[10.5px] t-label">para {s.customer_name} · <span className="mono">{s.id}</span></p>
              </button>
            ))}
          </div>
        </div>
      )}
      {deals.length > 0 && (
        <div className="ent-panel overflow-hidden" data-testid="sales-journey">
          <div className="ent-panel-head">Sales Operations <span className="num t-label ml-auto">{deals.length} deal(s) ativos</span></div>
          <div className="max-h-[360px] overflow-y-auto">
            <table className="ent-table">
              <thead>
                <tr>
                  <th>Cliente</th><th>Veículo</th><th>Estágio Atual</th>
                  <th className="hidden lg:table-cell">Responsável</th><th>Próxima Ação</th><th className="text-right">Tempo em Espera</th>
                </tr>
              </thead>
              <tbody>
                {deals.map((d) => (
                  <tr key={d.id} data-testid={`journey-${d.id}`} onClick={() => setDetailId(d.id)} className="cursor-pointer">
                    <td><p className="font-medium">{d.customer_name}</p><p className="text-[10px] t-label mono">{d.id}</p></td>
                    <td className="text-foreground/80">{d.vehicle_desc}</td>
                    <td><span className="ent-status text-muted-foreground"><span className="ent-dot text-primary" />{DEAL_STAGES[d.status]?.label || d.status}</span></td>
                    <td className="hidden lg:table-cell text-foreground/70">{d.salesperson_name}</td>
                    <td><span className="text-primary text-[12px] font-medium">{d.next_action}</span></td>
                    <td className={`text-right num ${d.deal_age >= 5 ? 't-bad' : d.deal_age >= 3 ? 't-warn' : 'text-muted-foreground'}`}>{d.deal_age}d</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <DealDetailDialog dealId={detailId} open={!!detailId} onClose={() => setDetailId(null)} onChanged={load} />
    </>
  );
};
